/* eslint-disable indent */
import { Inject, Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { combineLatest, map, Observable } from 'rxjs';

import {
	FEATURE_FLAG_SERVICE,
	CloudFeatureFlagsService,
	FeatureFlagIds
} from '@shure/cloud/shared/utils/feature-flags';

@Injectable({
	providedIn: 'root'
})
export class AppEnvironmentGuard {
	constructor(
		@Inject(FEATURE_FLAG_SERVICE) private readonly featureFlagsService: CloudFeatureFlagsService,
		private router: Router
	) {}

	public canActivate(envProps: FeatureFlagIds[]): Observable<boolean | UrlTree> {
		const checks$ = envProps.map((prop) => this.featureFlagsService.getFeatureFlag$(prop));

		return combineLatest(checks$).pipe(
			map((flags: boolean[]) => {
				const allEnabled = flags.every((isEnabled) => isEnabled);
				return allEnabled ? true : this.router.createUrlTree(['/']);
			})
		);
	}
}

/**
 * This is a partially applied function that allows us to provide arguments to our canActivate tokens
 * @param envProps - any boolean property in AppEnvironment
 */
export const appEnvironmentGuard =
	(envProps: FeatureFlagIds[]): CanActivateFn =>
	(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
		return inject(AppEnvironmentGuard).canActivate(envProps);
	};
